import {ILauncherServiceFactory} from './launcher-service-factory.interface';
import {IDomService} from '../../app-react/services/dom/dom.service.interface';
import {ILocationService} from '../../app-react/services/location/location.service.interface';
import {IWindowService} from '../../app-react/services/window/window.service.interface';
import {IStorageService} from '../../app-react/services/storage/storage.service.interface';
import {WindowService} from '../../app-react/services/window/window.service';
import {DomService} from '../../app-react/services/dom/dom.service';
import {StorageService} from '../../app-react/services/storage/storage.service';
import {ILoggerService} from '../../app-react/services/logger/logger.service.interface';
import {ConsoleLoggerService} from '../../app-react/services/logger/console-logger.service';
import {LocationService} from '../../app-react/services/location/location.service';
import {IOrbitConfigsStorageService} from './orbit-configs-storage/configs-storage.service.interface';
import {ConfigsStorageService} from './orbit-configs-storage/configs-storage.service';
import {ConfigurationsAreasService} from './configurations-areas/configurations-areas.service';
import {IRegulationService} from './regulation/regulation.service.interface';
import {RegulationService} from './regulation/regulations.service';
import {Lazy} from '../../utils/Lazy';
import {IPresetsService} from './presets/presets.service.interface';
import {PresetsService} from './presets/presets.service';
import {IHttpService} from '../../app-react/services/http/http.service.interface';
import {HttpService} from '../../app-react/services/http/http.service';
import {ISdmService} from './sdm/sdm.service.interface';
import {SdmService} from './sdm/sdm.service';
import {ILauncherDrawerService} from './launcher-drawer/launcher-drawer.service.interface';
import {LauncherDrawerService} from './launcher-drawer/launcher-drawer.service';
import {IDeviceTypeDetectionService} from './device-type-detection/device-type-detection.service.interface';
import {DeviceTypeDetectionService} from './device-type-detection/device-type-detection.service';
import {ILauncherSearchService} from './search/launcher-search.service.interface';
import {LauncherSearchService} from './search/launcher-search.service';
import {ILauncherRoutingService} from './routing/launcher-routing.service.interface';
import {LauncherRoutingService} from './routing/launcher-routing.service';
import {IGamesCustomizationService} from './games-customization/games-customization.service.interface';
import {GamesCustomizationService} from './games-customization/games-customization.service';


export class LauncherServiceFactory implements ILauncherServiceFactory {
    constructor(locationService: LocationService, localStorage: IStorageService, logger: ILoggerService) {
        this.logger = new ConsoleLoggerService(true);
        this.window = new WindowService();
        this.dom = new DomService();
        this.localStorage = new StorageService(this.logger);
        this.http = new HttpService();
        this.location = locationService;
        this._configurationsAreas.forceInit();
        this._sdm.forceInit();
        this._routing.forceInit();
        this._search.forceInit();
        this._configsStorage.forceInit();
    }

    readonly logger: ILoggerService;
    readonly window: IWindowService;
    readonly dom: IDomService;
    readonly http: IHttpService;
    readonly localStorage: IStorageService;
    readonly location: ILocationService;

    private _configsStorage = new Lazy<IOrbitConfigsStorageService>(() => new ConfigsStorageService(this));
    get configsStorage(): IOrbitConfigsStorageService {
        return this._configsStorage.value;
    }

    private _regulations = new Lazy<IRegulationService>(() => new RegulationService(this));
    get regulations(): IRegulationService {
        return this._regulations.value;
    }

    private _presets = new Lazy<IPresetsService>(() => new PresetsService(this));
    get presets(): IPresetsService {
        return this._presets.value;
    }

    private _configurationsAreas = new Lazy<ConfigurationsAreasService>(() => new ConfigurationsAreasService(this));
    get configurationsAreas(): ConfigurationsAreasService {
        return this._configurationsAreas.value;
    }

    private _sdm = new Lazy<ISdmService>(() => new SdmService(this));
    get sdm(): ISdmService {
        return this._sdm.value;
    }

    private _drawer = new Lazy<ILauncherDrawerService>(() => new LauncherDrawerService(this));
    get drawer(): ILauncherDrawerService {
        return this._drawer.value;
    }

    private _deviceTypeDetection = new Lazy<IDeviceTypeDetectionService>(() => new DeviceTypeDetectionService(this));
    get deviceTypeDetection(): IDeviceTypeDetectionService {
        return this._deviceTypeDetection.value;
    }

    private _search = new Lazy<ILauncherSearchService>(() => new LauncherSearchService(this));
    get search(): ILauncherSearchService {
        return this._search.value;
    }

    private _routing = new Lazy<ILauncherRoutingService>(() => new LauncherRoutingService(this));
    get routing(): ILauncherRoutingService {
        return this._routing.value;
    }

    private _gamesCustomization = new Lazy<IGamesCustomizationService>(() => new GamesCustomizationService(this));
    get gamesCustomization(): IGamesCustomizationService {
        return this._gamesCustomization.value;
    }

}